export default __webpack_public_path__ + "static/media/integrately.c26be803.png";